import { writable } from 'svelte/store';
import collect from 'collect.js';
// Models
import Classification from '@/Models/Classification.js';
import RacingProduct from '@/Models/RacingProduct.js';
import BetType from '@/Models/BetType.js';
// Stores
import ClassificationBetTypeStore from '@/Stores/Racing/ClassificationBetTypeStore.js';
import BetTypeStore from '@/Stores/Racing/BetTypeStore.js';
import ProductStore from '@/Stores/Racing/ProductStore.js';
import { mergeCollectionStore } from '@/Stores/StoreHelpers.js';
// Constants
import { BetCategory } from '@/Constants/Bet.js';

/**
 * Our Store can be used 2 ways in svelte components
 * 1) ($ prefix) $StoreName to reference writable store collection with all collect.js methods available
 * 2) (Direct) StoreName.method() to call a method on the store
 */
const init = () => {
	// eslint-disable-next-line no-unused-vars
	let _store;

	const { subscribe, set, update } = writable(collect());

	subscribe((current) => (_store = current));

	let meta;

	const methods = {
		getPagination() {
			return meta && meta.pagination;
		},

		getClassifications(betCategoryId = BetCategory.Racing, pagination = null) {
			const classification = new Classification();

			let results = pagination
				? classification.where('bet_category_id', betCategoryId).paginate(pagination.size, pagination.number)
				: classification.where('bet_category_id', betCategoryId).get();
			return results
				.then((result) => {
					meta = result.meta;
					set(result.data);
				})
				.catch((e) => {
					console.error(e);
				});
		},

		getClassification(classificationId) {
			const classification = new Classification();
			return classification
				.find(classificationId)
				.then((result) => {
					meta = result.meta;
					set(collect([result]));
				})
				.catch((e) => {
					console.error(e);
				});
		},

		getClassificationWithBetTypes(id) {
			const product = new RacingProduct();
			const betType = new BetType();
			const classification = new Classification();
			let allClassBetTypes = collect();

			let allProducts = product.get().then((result) => {
				ProductStore.set(result.data);
			});

			let allBetTypes = betType.get().then((result) => {
				BetTypeStore.set(result.data);
			});

			let classData = classification
				.with(['bet_types'])
				.find(id)
				.then((result) => {
					result.bet_types.data.map((betType) => {
						betType.classification_id = result.id;
						allClassBetTypes.push(betType);
					});
					ClassificationBetTypeStore.set(allClassBetTypes);

					delete result.bet_types;

					mergeCollectionStore(this, collect([result]));
				})
				.catch((e) => {
					console.error(e);
				});

			return Promise.all([allProducts, allBetTypes, classData]);
		}
	};

	return {
		subscribe,
		update,
		set,
		...methods
	};
};

export default init();
